import './vendor';
import {init} from './mixpanel';
import year from './components/year';
import faq from './components/faq';
import aos from './components/aos';
import sign from './components/sign';

document.addEventListener('DOMContentLoaded', () => {
	year.init();
	faq.init();
	aos.init();
	sign.init();
	init();
});
